import { Link, useSearchParams } from "react-router-dom";
import classNames from "utilities/ClassNames";
import { AddNewItemBtn } from "components/shared/buttons/AddNewItemBtn";
import { Tooltip } from "react-tooltip";
import TextOverflow from "utilities/TextOverflow";
import { SmallestLoader } from "components/shared/Loader";
import { FiHelpCircle } from "react-icons/fi";
import { useEffect, useState } from "react";
import GuidesModal from "components/guides/GuidesModal";
import useApp from "hooks/useApp";
import { useOrganization } from "hooks/OrganizationContext";
import SmartImg from "assets/Smart.jpg";
import EnergyImg from "assets/Energy.jpg"; // Fix the typo
import CyberImg from "assets/CyberImg.jpg";
import DemoImage from "assets/Saudi-Logistic-HUB3.jpg";
import { CiLock } from "react-icons/ci";
import Logo from "assets/symbol-logo.png";

const ProjectContainer: React.FC<any> = ({ data, handleAddNew, isDisabled, isLoading, setSelectedProject, productId, activeTab}) => {
  const [showGuidesModal, setShowGuidesModal] = useState(false);
  const [showAddNewButton, setShowAddNewButton] = useState(false);
  const [isShowBtnLoading, setIsShowBtnLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const onEditClick = (project: any) => {
    // Safely parse coordinates if they exist, otherwise set to null
    let parsedCoordinates = null;
    if (project.coordinates && typeof project.coordinates === 'string') {
      try {
        parsedCoordinates = JSON.parse(project.coordinates);
      } catch (error) {
        console.warn('Failed to parse project coordinates:', error);
        parsedCoordinates = null;
      }
    }

    console.log("project", project);
    
    setSelectedProject({ ...project, coordinates: parsedCoordinates });
  };

  const { user } = useApp();
  const isAdmin = user?.role.includes('admin');
  const { selectedOrganization } = useOrganization();

  useEffect(() => {
    if (searchParams.get("more") === "true") {
      setShowGuidesModal(true);
    }
  }, [searchParams]);


  useEffect(() => {
    setIsShowBtnLoading(false);
    const timeoutId = setTimeout(() => {
      const showAddNewProjectButton = isAdmin ? true :
        (data.filter((project: any) => (
         project.isEditable && (project.code !== "AAABBB" || project.code !== "AAACTY")
        )).length >= 1) || selectedOrganization.id === "0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f" ? false : !isDisabled;

      setShowAddNewButton(showAddNewProjectButton);
      setIsShowBtnLoading(true);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [isAdmin, data, selectedOrganization, isDisabled]);

  const getBackgroundImage = (category: string) => {
    switch (category?.toLowerCase()) {
      case "smartcity":
        return SmartImg;
      case "energy":
        return EnergyImg;
      case "cybersecurity":
        return CyberImg;
      default:
        return DemoImage;
    }
  };

  const filteredData = () => {
    if (productId) {
      const staticData = data.filter((project: any) => project.productId === undefined);
      const filteredData = data.filter((project: any) => project.productId === productId);
      const allData = [ ...staticData, ...filteredData ];
      return allData;
    }
    return data;
  };


  return (
    <div
      className="flex h-[calc(100vh-347px)] 2xl:h-[calc(100vh-350px)] bg-[#232323] overflow-hidden overflow-y-auto flex-col gap-1 2xl:gap-4 rounded-md  p-4 shadow-2xl"
    // style={{
    //   background:
    //     "linear-gradient(180deg, rgba(180, 180, 180, 0.35) 0%, rgba(180, 180, 180, 0.15) 100%)",
    // }}
    >
      <div className="flex flex-col flex-grow gap-2">
        <div className="flex-grow">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5  gap-2 gap-y-2">
            {filteredData().map((project: any, index: any) => {
              // Determine if edit button should be shown
              const showEditButton = (project.code === "AAABBB" || project.code === "AAACTY") ? (isAdmin && project.isEditable) ? true : false : project.isEditable;

              return (
                <Link
                  key={index}
                  target="_blank"
                  onClick={(e) => {
                    const target = e.target as HTMLElement;
                    if (target.closest(".edit-button")) {
                      e.preventDefault();
                    }
                  }}
                  to={project.link ? project.link : ''}
                  className={classNames(
                    project.link && project.link.length > 0 ? "cursor-pointer" : "cursor-default",
                    `h-[120px] w-full relative bg-cover bg-center rounded-md p-[10px] shadow-[0_4px_12px_rgba(0,0,0,0.2)]`
                  )}
                  style={{ backgroundImage: `url(${getBackgroundImage(project.industry)})`, position: "relative" }}

                >
                  <div className="absolute z-[1] bg-[rgba(0,0,0,.5)] w-full h-full top-0 left-0"></div>
                  <div className="relative z-50  h-full">
                    <div className="flex items-center justify-between z-50">
                      {project.status === "Private Project" && <CiLock />}
                      <div className="flex items-center gap-2">
                        <p className={`text-[10px]  ${project.industry === "ENERGY" || project.industry === "Energy" ? "text-[#ECBD93]" : project.industry === "CYBERSECURITY" || project.industry === "Cyber Security" ? "text-[#A8BEEC]" : "text-[#A8BEEC]"} z-50`}>{project.industry}</p>
                        {showEditButton && <button
                          className="cursor-pointer edit-button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onEditClick(project);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="18px"
                            viewBox="0 -960 960 960"
                            width="18px"
                            fill="#FFFFFF"
                          >
                            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                          </svg>
                        </button>}
                      </div>
                    </div>
                    {
                    project.productId &&
                      <img className="w-8 mt-3 ml-auto absolute -bottom-1 w-[25px] right-0" src={Logo} alt="" />}
                    <div className="absolute bottom-0 left-0">
                      <h4 
                        className="z-50 font-normal"
                        data-tooltip-id={`project-title-${index}`}
                        data-tooltip-content={project.title}
                      >
                        {TextOverflow(project.title, 12)}
                      </h4>
                      <h6 className=" z-50 text-xs font-normal text-white opacity-50">
                        {project.type}
                      </h6>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
        <div className="flex justify-between mt-auto">
          {!isDisabled && <button
            onClick={() => setShowGuidesModal(true)}
            className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:text-white transition-colors rounded-md hover:bg-white/[0.08]"
            data-tooltip-id="need-help-tooltip"
            data-tooltip-content="View guides and tutorials"
          >
            <FiHelpCircle size={15} />
            <span className="text-sm">Need Help?</span>
          </button>}
          {isShowBtnLoading && showAddNewButton && (
            <AddNewItemBtn
              onClick={handleAddNew}
              btnType="filled"
              type="submit"
              isDisabled={isDisabled}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="15px"
                viewBox="0 -960 960 960"
                width="15px"
                fill="#FFFFFF"
              >
                <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
              </svg>
              Add New
            </AddNewItemBtn>
          )}
        </div>
      </div>

      <GuidesModal
      activeTab={activeTab}
        isOpen={showGuidesModal}
        onClose={() => {
          setShowGuidesModal(false);
          searchParams.delete("more");
          setSearchParams(searchParams, { replace: true });
        }}
      />

      <Tooltip
        id="need-help-tooltip"
        place="top"
        className="bg-[#1A1A1A] z-50 border border-white/[0.08] !opacity-100"
        style={{
          fontSize: '0.875rem',
          padding: '0.5rem 0.75rem'
        }}
      />

      {filteredData().map((project: any, index: any) => (
        <Tooltip
          key={`project-title-${index}`}
          id={`project-title-${index}`}
          place="top"
          className="bg-[#1A1A1A] z-50 border border-white/[0.08] !opacity-100"
          style={{
            fontSize: '0.875rem',
            padding: '0.5rem 0.75rem'
          }}
        />
      ))}
    </div>
  );
};

export default ProjectContainer;
